const discountCouponsTranslations = {
  es: {
    table: {
      breadcrumbs:{
        title: 'Configuracion de Cupon de Descuento',
        description:'Administracion de Cupon de Descuento'
      },
      headers: {
        description: 'Nombre',
        code: 'Código',
        status: {
          title:'Estado',
          actives: 'Activos',
          inactives: 'Inactivos'
        },
        nameCareer: 'Nombre de carrera',
        zones: 'Zonas',
        studentType:  {
          title:'Tipo de Estudiante',
          ni: 'Ingresante',
          ri: 'Reingresante',
        },
        term: 'Periodos'
      },
      search:{
        gotopage:' Ir a pagina'
      },
      actions: {
        delete: 'Eliminar Cupon de Descuento',
        bulkDelete: 'Eliminar Cupones de Descuentos',
      },
      messages: {
        popup:{
          title: '¿Esta seguro de deshabilitar?'
        },
        errors:{
          delete: 'No se pudo eliminar el Cupon de Descuento seleccionado',
          bulkDelete: 'No se pudieron eliminar los Cupones de Descuentos seleccionados'
        },
        success:{
          bulkDelete: 'Los Cupones de Descuentos se eliminaron correctamente',
          delete: 'El Cupon de Descuento se elimino correctamente'
        }
      }
    },
    create: {
      breadcrumbs:{
        title: 'Nuevo Cupon de Descuento',
        description:'Crea un nuevo Cupon de Descuento'
      },
      products: {
        title: 'Producto',
        subtitle: 'Selecciona el producto al que se aplicará el cupón de descuento',
        items: {
          product: 'Producto'
        }
      },
      studentSection: {
        title: 'Tipo de estudiantes',
      },
      codeSection:{
        title:'Datos del Cupon de Descuento',
        subtitle:'Asigna la información básica del Cupon de Descuento que estás creando. Recuerda que estos datos deben ser lo más descriptivos posible ya que serán utilizados para futuros filtros de búsqueda.',
        labels: {
          name: 'Nombre',
          code: 'Código',
          discountType: 'Tipo de descuento',
          amountDiscount:'Monto',
          percentageDiscount:'Porcentaje',
          dateFrom: 'Aplica desde',
          dateTo: 'Aplica hasta',
          manualAssignation: 'Asignacion manual del descuento'
        }
      },
      sectionCondition:{
        title:'Condiciones',
        subtitle: '',
        labels:{
          minPayment: 'Monto mínimo aplicable',
          maxDiscount: 'Monto máximo a descontar',
        }
      },
      sectionRestriction:{
        title:'Restricciones',
        subtitle: '',
        labels:{
          radioFirst: 'Sin restricción',
          radioSecond: 'Límite de estudiantes',
        }
      },
      termSection: {
        title: 'Periodos',
        subtitle: 'Selecciona en esta sección los periodos donde este beneficio extra puede ser aplicado',
        transferList: {
          firstTitle: 'Disponibles',
          secondTitle: 'Seleccionados'
        }
      },
      zoneSection: {
        title: 'Zonas'
      },
      careersSection: {
        title: 'Carreras',
        subtitle: 'Selecciona las carreras a las que quiere asignarles el Cupon de Descuento',
        transferList: {
          firstTitle: 'Disponibles',
          secondTitle: 'Seleccionadas'
        }
      },
      successMessage: {
        title: 'Cupon de Descuento creado correctamente',
      },
      errorMessage: {
        title: 'Ocurrió un error al crear el Cupon de Descuento',
      }
    },
    update: {
      breadcrumbs: {
        title: 'Editar Cupon de Descuento',
        description:'Modifica el Cupon de Descuento seleccionado',
      },
      codeSection: {
        title: 'Datos del Cupon de Descuento',
        subtitle: 'Modifica la información básica del Cupon de Descuento que estás modificando. Recuerda que estos datos deben ser lo más descriptivos posible ya que serán utilizados para futuros filtros de búsqueda.',
        labels: {
          name: 'Nombre',
          code: 'Código'
        },
      },
      studentSection: {
        title: 'Tipo de estudiantes',
      },
      termSection: {
        title: 'Periodos',
        subtitle: 'Selecciona en esta sección los periodos donde este Cupon de Descuento puede ser aplicado',
        transferList: {
          firstTitle: 'Disponibles',
          secondTitle: 'Seleccionados'
        }
      },
      zoneSection: {
        title: 'Zonas'
      },
      careersSection: {
        title: 'Carreras',
        subtitle: 'Selecciona las carreras a las que quiere asignarles el Cupon de Descuento',
        transferList: {
          firstTitle: 'Disponibles',
          secondTitle: 'Seleccionadas'
        }
      },
      successMessage: {
        title: 'Cupon de Descuento modificado correctamente',
      },
      errorMessage: {
        title: 'Ocurrió un error al modificar el Cupon de Descuento',
      }
    },
    details:{
      drawer:{
        title:'Nuevo estudiante beneficiado',
        subtitle:'Agrega un nuevo estudiante al beneficio.',
        students:{
          title: 'Estudiantes',
          description: 'Aquí podrás seleccionar a quienes asignarle un Cupon de descuento. Ten en cuenta que si el estudiante que buscas no está disponible en esta lista es posible que ya tenga un cupon asignado o no cumpla los requisitos necesarios.',
          table:{
            identification: 'Identificacion',
            name:'Nombre',
            careerDescription: 'Carrera',
            usescouponUsesCount: 'Usos'
          }
        },
      },
      studentsWithCoupons:{
        resume:{
          discount: 'Descuento',
          minPayment: 'Pago minimo',
          maxDiscount: 'Máximo a descontar',
          maxUsagesPerUser:'Usos por usuario',
          dateFrom: 'Aplica desde',
          dateTo: 'Aplica hasta',
          BenefitsStudents: 'Estudiantes beneficiados',
          maxBenefitsStudents: 'Cupos disponibles',
          totalUses:'Cantidad de usos totales',
          productType: 'Tipo de producto'
        },
        actions:{
          deleteStudents: 'Eliminar descuento a Estudiantes',
          addStudents: 'Agregar nuevo Estudiante'
        },
        popup:{
          assigned:{
            errors:{
              maxUsers:'Esta excediendo el cupo maximo de estudiantes.',
              general: 'Error al asignar cupones intentelo mas tarde.'
            }
          },
          delete:{
            title:'¿Esta seguro de eliminar?',
            errors:{
              general: 'Error al eliminar cupones intentelo mas tarde.'
            }
          }
        }
      }
    },
    validations: {
      nameRequired: 'Ingresa el nombre del Cupon de Descuento',
      nameAlphanumericWithSpaces: 'Solo alfanuméricos',
      nameMaxLength: 'Máximo 60 caracteres',
      codeRequired: 'Ingresa el código del Cupon de Descuento',
      codeAlphanumeric: 'Solo alfanuméricos',
      codeMaxLength: 'Máximo 16 caracteres',
      codeMinLength: 'Minimo 5 caracteres',
      codeUnique: 'Código ya existente',
      productRequired: 'Debe seleccionar un producto',
      studentType: 'Debe seleccionar un tipo de estudiante',
      term: 'Seleccione un periodo',
      dateFromRequired: 'Debe ingresar un día de inicio',
      dateToRequired: 'Debe ingresar un día de fin',
      uniqueRange: 'Rango de días ya existente',
      betweenValues: 'Debe ser entre 1 y 30',
      percentageRequired: 'Debe ingresar un porcentaje',
      amountRequired: 'Debe ingresar un monto',
      amount: 'Debe ingresar un monto valido',
      amountMustBeGreaterThanMinPayment: 'El pago minimo debe ser mayor al monto del cupon',
      percentageBetweenValues: 'El número debe estar entre 1 y 100, con dos dígitos después del punto decimal',
      zone: 'Debe seleccionar al menos una zona',
      noSelectedTerms: 'Debes seleccionar al menos un periodo',
      noSelectedCareers: 'Debes seleccionar al menos una carrera',
      maxUsagesPerUserRequired: 'Ingresa la cantidad maxima de usos',
      selectedStudentTypeRequired: 'Debe seleccionar almenos un tipo de estudiante',
      limitMinValue: 'Debe ser un entero mayor a 0',
      limitRequired: 'El límite es requerido'
    }
  },
  es_CL: {},
  es_PE:{},
  es_MX:{},
  en: {}
}

export default discountCouponsTranslations
